export default "__VITE_ASSET__9bkjt4hs__"